import CancelablePromise from 'cancelable-promise';
import { ApiResult } from '../types/ApiResult';
import apiClient from './appApi';

export type EmailValidationResult = {
  emailAddress: string;
  isValid: boolean;
  suggestion?: string;
};

export default function validateEmail(emailAddress: string): CancelablePromise<ApiResult<EmailValidationResult>> {
  return apiClient.post<ApiResult<EmailValidationResult>, {}>('/CMSPages/SonovaBookAppointment/ValidateEmail.ashx', {
    emailAddress,
  });
}
